export class PublicLinkService {
  static $inject = ['$resource'];

  private resource: any;

  constructor($resource) {
    this.resource = $resource('/api/token');
  }

  get(...args) {
    return this.resource.get(...args);
  }

  save(...args) {
    return this.resource.save(...args);
  }
}
